module.exports = __webpack_public_path__ + "img/69.d0b508b2.jpg";